import {registerGraph, mergeGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('dashboardCurrentLimitGraph', dashboardCurrentLimitGraph);

/* @ngInject */
function dashboardCurrentLimitGraph(GraphService, dashboardGraph) {
    const GraphColors = GraphService.colors;
    return mergeGraph(dashboardGraph(), {
        options: {
            chart: {
                type: 'pie',
                marginTop: 0,
                spacing: [0, 0, 0, 0]
            },
            lang: {
                noData: false
            },
            title: {
                text: undefined,
                floating: true,
            },
            pane: {
                size: '100%'
            },
            plotOptions: {
                pie: {
                    colors: ['#c5e4b133', 'transparent'],
                    size: '100%',
                    slicedOffset: '0',
                    borderWidth: 1,
                    //opacity: 0.2,
                    dataLabels: {
                        enabled: false
                    },
                    enableMouseTracking: false
                },
            },
        },
        size: {
            height: null
        },
        series: [
            {
                data: [
                    {
                        borderColor: GraphColors.lightGreen,
                        sliced: true
                    }, {}
                ]
            }
        ]
    });
}
